import {getElementById, getSelectValue, hideElement, showElement} from './dom';

export function setupIncludedInCatalogue(): void {
    const addItemBtn = getElementById('add_item_to_catalogue');
    const addItemDiv = getElementById('add_item_to_catalogue_div');
    if (!addItemBtn || !addItemDiv) {
        return;
    }

    hideElement(addItemDiv);

    addItemBtn.addEventListener('click', (event) => {
        event.preventDefault();
        showElement(addItemDiv);
    });

    getElementById('add_item_to_catalogue_button')?.addEventListener('click', (event) => {
        event.preventDefault();
        const form = getElementById<HTMLFormElement>('add_item_to_catalogue_form');
        const catalogueId = getSelectValue('#sales_catalogue_id');
        if (!form || !catalogueId) {
            return;
        }
        form.action = `/admin/newcatalogueentity/catalogue/${catalogueId}`;
        form.submit();
    });
}
